import { useFeature } from '@modules/root';
import { useFFPaintPickerContext as useFFPaintPickerContextV1 } from '@modules/paint-picker/context/PaintPickerContext';
import { useFFPaintPickerContext as useFFPaintPickerContextV2 } from '@modules/paint-picker-new/context/PaintPickerContext';

export const useFeatureFlaggedPaintPickerContext = () => {
    const newResenePickerEnabled = useFeature('resene_color_picker_2024');
    const v1PickerContext = useFFPaintPickerContextV1(newResenePickerEnabled);
    const v2PickerContext = useFFPaintPickerContextV2(newResenePickerEnabled);
    const pickerContext = v2PickerContext || v1PickerContext;

    if (pickerContext !== undefined) {
        return { pickerContext, newResenePickerEnabled };
    }

    throw new Error('No pickerContext found');
};
